import { matchRoutes, type RouteObject } from "react-router-dom";
import type { RouteConfig } from "providers/Routes/types";

const CATCH_ALL = "*";

export const toRouteObjects = (routes: RouteConfig[]): RouteObject[] =>
  routes
    .filter((route) => route.when !== false && route.path !== CATCH_ALL)
    .map((route) => ({
      path: route.path,
      children: route.children ? toRouteObjects(route.children) : undefined
    }));

export const isPathAvailable = (routes: RouteObject[], path: string) => {
  const pathname = path.split(/[?#]/)[0];
  return Boolean(matchRoutes(routes, pathname)?.length);
};
